import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { setSearch } from './rulesUiSlice';

export function RuleSearch() {
  const dispatch = useAppDispatch();
  const search = useAppSelector((s) => s.rulesUi.search);

  return (
    <div style={{ padding: '0 14px 10px' }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 9,
          height: 34,
          padding: '0 11px',
          background: 'var(--surface-card)',
          border: '1px solid var(--border)',
          borderRadius: 8,
        }}
      >
        <span style={{ color: 'var(--text-faint)', fontSize: 13 }}>⌕</span>
        <input
          value={search}
          onChange={(e) => dispatch(setSearch(e.target.value))}
          placeholder="Filter rules…"
          style={{
            flex: 1,
            background: 'transparent',
            border: 'none',
            outline: 'none',
            color: 'var(--text-primary)',
            fontSize: 13,
            fontFamily: 'var(--font-sans)',
          }}
        />
      </div>
    </div>
  );
}
